import React, { useState, useEffect, useCallback } from "react";
// import styled from "styled-components";
import { useTable, usePagination, useSortBy } from "react-table";
import {
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";

function TableView({ columns, data,customPageSize ,sumhours,sumbillable,estimated,onchangeApprovestatus,curstatus,handleSubmit,handleChange,curstatusList,disablePagination}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    rows, // All rows (used when disablePagination is true)

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      
      defaultCanSort: true,
      initialState: { pageIndex: 0 ,
        sortBy: [{ id: "Name", asc: true }]},
    },
    useSortBy,
    usePagination
  );
  useEffect(() => {
    // set the page size to 5.
    setPageSize(customPageSize);
  }, [setPageSize]);
  const displayedRows = disablePagination ? rows : page;
  let optionselect=[];
  optionselect.push({value :0 ,label:"Select"},{value :1 ,label:"Approve"},{value :2 ,label:"Reject"})
  // Render the UI for your table
  return (
    <>
      {/* <div style={{ width: "100%", overflowY: "auto" }}> */}
      
        {/* <tr>
          <td> */}
        {/* <div style={{ width: "500px", height: "180px", overflow: "auto" }}> */}
        <div
          className="main-div"
          // style={{ width: "500px", height: "180px", overflow: "auto" }}
        >
          <Table hover {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup, p) => (
                <tr key={p} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                   
                    >
                      {/* Add a sort direction indicator */}
                      <span className="">
                        {column.render("Header")}

                       
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {displayedRows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr key={i} {...row.getRowProps()}>
                    {row.cells.map((cell, k) => {
                      return (
                        <td key={k} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                
                );
              })}
    
            </tbody>
          </Table>
        </div>
     
      {/* </div> */}
    </>
  );
}


const TableWithSorPagtn = React.memo((props) => {

  const { thead } = props;
  
  const columns = React.useMemo(
    () =>
      thead.map((el, i) => {
        return { Header: el, accessor: el };
      }),
    [thead]
  );
  const data = React.useMemo(() => props.trow, [props.trow]);
  return (
    // <Styles>

    <TableView columns={columns} data={data} customPageSize={props.pageSize} sumhours={props.sumhours} sumbillable={props.sumbillable} estimated={props.estimated} onchangeApprovestatus={props.onchangeApprovestatus} curstatus={props.curstatus} handleSubmit={props.handleSubmit} handleChange={props.handleChange} curstatusList={props.curstatusList} disablePagination={props.disablePagination} />
    // </Styles>
  );
});

export default TableWithSorPagtn;
